
import {
  GET_DSCO_INVOICE_REPORT_REQUEST,
  GET_DSCO_INVOICE_REPORT_SUCCESS,
  GET_DSCO_INVOICE_REPORT_ERROR,
} from "../actions/types";

export const dscoInvoice = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_DSCO_INVOICE_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_DSCO_INVOICE_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_DSCO_INVOICE_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};